import styled from 'styled-components';
import { s } from './VIPReport.style';

const ReturnAnalysis = () => {
  return (
    <s.Div>
      <s.Title>💸수익률 시뮬레이션</s.Title>
      <StepDiv>
        <Step>
          <Num>1</Num>
          <div>예상 선투입비용</div>
        </Step>
        <s.Table>
          <s.TableHeader>
            <s.Header>항목</s.Header>
            <s.Header>금액</s.Header>
          </s.TableHeader>
          <s.Row>
            <RowLeft>입찰가</RowLeft>
            <RowRight>금액</RowRight>
          </s.Row>
          <s.Row>
            <RowLeft>취득세/법무비 등 부대비용</RowLeft>
            <RowRight>금액</RowRight>
          </s.Row>
          <s.Row style={{ backgroundColor: '#F0F8FF' }}>
            <RowLeft>총 선투입비</RowLeft>
            <RowRight style={{ color: '#008aff' }}>금액</RowRight>
          </s.Row>
        </s.Table>
      </StepDiv>
      <StepDiv>
        <Step>
          <Num>2</Num>
          <div>경락잔금대출 회수 예상</div>
        </Step>
        <ColumnBox>
          <ColumnTitle>예상 대출금</ColumnTitle>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <ColumnNum>금액</ColumnNum>
            <ColumnBottom>입찰가의 nn%</ColumnBottom>
          </div>
        </ColumnBox>
        <ColumnBox>
          <ColumnTitle>실투자금 = 선투입비 - 대출금</ColumnTitle>
          <ColumnNum>금액</ColumnNum>
        </ColumnBox>
      </StepDiv>
      <StepDiv>
        <Step>
          <Num>3</Num>
          <div>수익 계산</div>
        </Step>
        <ColumnBox style={{ gap: '24px' }}>
          <div>
            <ColumnTitle>매매차익</ColumnTitle>
            <div>
              <ColumnNum style={{ color: '#616161' }}>금액</ColumnNum>
              <ColumnBottom>금액 - 금액</ColumnBottom>
            </div>
          </div>
          <div>
            <ColumnTitle>예상 이자비용</ColumnTitle>
            <div>
              <ColumnNum style={{ color: '#616161' }}>금액</ColumnNum>
              <ColumnBottom>6개월 기준 추정</ColumnBottom>
            </div>
          </div>
          <div>
            <ColumnTitle>예상 세후이익</ColumnTitle>
            <div>
              <ColumnNum>금액</ColumnNum>
              <ColumnBottom>금액 - 이자 - 세금 등</ColumnBottom>
            </div>
          </div>
        </ColumnBox>
      </StepDiv>
      <StepDiv>
        <Step>
          <Num>4</Num>
          <div>수익률 지표</div>
        </Step>
        <RowBox>
          <div>
            <ColumnTitle>ROI (총 투자 대비 수익률)</ColumnTitle>
            <div>
              <ColumnNum>%</ColumnNum>
              <ColumnBottom>세후이익 ÷ 선투입비</ColumnBottom>
            </div>
          </div>
          <div>
            <ColumnTitle>ROE (자기자본 수익률)</ColumnTitle>
            <div>
              <ColumnNum>%</ColumnNum>
              <ColumnBottom>세후이익 ÷ 실투자금</ColumnBottom>
            </div>
          </div>
        </RowBox>
      </StepDiv>

      <s.BottomDescription>
        <div>
          ROI는 전체 투자 대비 수익, ROE는 내 돈으로 얼마 벌었는지 보는
          지표예요.
          <br />
          레버리지를 얼마나 잘 쓰느냐에 따라 ROE는 훨씬 강력해질 수 있습니다.
        </div>
      </s.BottomDescription>
    </s.Div>
  );
};

export default ReturnAnalysis;

const RowLeft = styled.div`
  width: 160px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: start;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const RowRight = styled.div`
  width: calc(100% - 160px);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const StepDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Step = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #222222;
`;

const Num = styled.div`
  padding: 10px;
  background-color: #e6f3ff;
  border-radius: 6px;
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 700;
  color: #008aff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ColumnBox = styled.div`
  width: 100%;
  padding: 24px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;

const ColumnTitle = styled.div`
  text-align: center;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  color: #222222;
  margin-bottom: 4px;
`;

const ColumnNum = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 700;
  color: #008aff;
  line-height: 145%;
`;

const ColumnBottom = styled.div`
  font-size: 12px;
  text-align: center;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const RowBox = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  border-radius: 16px;
  border: 1px solid #e5e8ea;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;
